<template>
  <div class="SayfaContainer">
    <div class="SayfaBaslik" v-if="!Tur">
      <h1>{{ Unvan }}</h1>
      <div class="SayfaBtn el-button-group">
        <el-button size="small" type="default" @click="SayfaYukle" :disabled="lo">YENİLE</el-button>
        <el-button size="small" type="default" @click="Yazdir" :disabled="lo">Yazdır</el-button>
        <el-button size="small" type="default" @click="Indir" :disabled="lo">İndir</el-button>
        <el-button size="small" type="default" @click="OdemeModalDurum=true" :disabled="lo">ÖDEME İŞLE</el-button>
        <el-button size="small" type="default" @click="HareketModalDurum=true" :disabled="lo">HAREKET İŞLE</el-button>
        <el-button size="small" type="default" @click="CariModalDurum=true" :disabled="lo">DÜZENLE</el-button>
      </div>
    </div>
    <div class="SayfaIcerik" v-loading="lo">
      <div class="yazdirtable" v-if="Ekstre">
        <h1>{{ SayfaAdi }}</h1>
        <table class="table table-bordered">
          <thead>
          <tr>
            <td>No.</td>
            <td>Tarih</td>
            <td>Tür</td>
            <td>Açıklama</td>
            <td class="text-right">Borç</td>
            <td class="text-right">Alacak</td>
            <td class="text-right">KAlan</td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="t in Ekstre">
            <td>{{ t.id }}</td>
            <td>{{ t.tarih }}</td>
            <td>{{ t.TurText }}</td>
            <td>{{ t.Aciklama }}</td>
            <td class="text-right">{{ t.AText }}</td>
            <td class="text-right">{{ t.VText }}</td>
            <td class="text-right">{{ t.BText }}</td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <td colspan="4"></td>
            <td class="text-right">{{ AltToplam.A }}</td>
            <td class="text-right">{{ AltToplam.V }}</td>
            <td class="text-right">{{ AltToplam.B }}</td>
          </tr>
          </tfoot>
        </table>

      </div>
      <el-row class="yazdirma">
        <el-col :sm="24" :md="20" class="pr-10">
          <el-alert
              v-if="!Ekstre"
              title="Hareket bulunamadı"
              type="info"
              :closable="false">
          </el-alert>
          <el-table
              v-if="Ekstre"
              :data="Ekstre"
              class="table-xs table-hover"
              @current-change="TableSecim"
              :height="Height"
              show-summary
              :summary-method="TableFooter">
            <el-table-column label="No." prop="id" width="50"></el-table-column>
            <el-table-column label="Tarih" prop="tarih" width="100"></el-table-column>
            <el-table-column label="Tür" prop="TurText" width="100"></el-table-column>
            <el-table-column label="Açıklama" prop="Aciklama"></el-table-column>
            <el-table-column label="Borç" prop="AText" width="100" align="right"></el-table-column>
            <el-table-column label="Alacak" prop="VText" width="100" align="right"></el-table-column>
            <el-table-column label="Bakiye" prop="BText" width="100" align="right"></el-table-column>
          </el-table>
        </el-col>
        <el-col :sm="24" :md="4">
          <table v-if="Bilgi" class="table table-sm bilgi-table">
            <thead>
            <tr>
              <th>Cari Bilgi</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>
                <small class="d-block">Cari Kodu</small>
                {{ Bilgi.id }}
              </td>
            </tr>
            <tr>
              <td>
                <small class="d-block">Ünvan</small>
                {{ Bilgi.Unvan }}
              </td>
            </tr>
            <tr v-if="Bilgi.Telefon">
              <td>
                <small class="d-block">Telefon</small>
                {{ Bilgi.Telefon }}
              </td>
            </tr>
            <tr v-if="Bilgi.Email">
              <td>
                <small class="d-block">Email</small>
                {{ Bilgi.Email }}
              </td>
            </tr>
            <tr v-if="Bilgi.vNo || Bilgi.vDaire">
              <td>
                <small class="d-block">Vergi No/Daire</small>
                {{ Bilgi.vNo }} <br> {{ Bilgi.vDaire }}
              </td>
            </tr>
            <tr v-if="Bilgi.Yetkili || Bilgi.YetkiliTel">
              <td>
                <small class="d-block">Yetkili/Yetkili Telefon</small>
                {{ Bilgi.Yetkili }} <br> {{ Bilgi.YetkiliTel }}
              </td>
            </tr>
            <tr v-if="Bilgi.Grup" class="text-primary">
              <td>
                <small class="d-block">Grup</small>
                {{ Bilgi.Grup }}
              </td>
            </tr>
            </tbody>
          </table>
        </el-col>
      </el-row>
    </div>
    <CariModal v-if="CariModalDurum" :Bilgi="Bilgi" @Durum="SayfaYukle" :Durum="CariModalDurum"></CariModal>
    <el-dialog
        :close-on-click-modal="false"
        v-if="Detay"
        :title="Detay.id+' NOLU '+Detay.TurText"
        :visible.sync="DetayModalDurum"
        :before-close="DetayModalKapat"
        :v-loading="lo"
        width="30%"
        append-to-body>
      <table class="table table-bordered table-sm" v-if="Detay">
        <tbody>
        <tr>
          <td>
            <small class="d-block">Hareket Türü</small>
            {{ Detay.TurText }}
          </td>
          <td class="text-right text-primary">
            <small class="d-block">Hareket Tutarı</small>
            <b>{{ Detay.TutarText }}</b>
          </td>
          <td class="text-right">
            <small class="d-block">Hareket Sonrası Bakiye</small>
            {{ Detay.BText }}
          </td>
        </tr>
        <tr>
          <td colspan="3">
            <small class="d-block">Açıklama</small>
            {{ Detay.HamAciklama }}
          </td>
        </tr>
        <tr v-if="Detay.eFaturaNo">
          <td colspan="3">
            <small class="d-block">E-Fatura No</small>
            {{ Detay.eFaturaNo }}
          </td>
        </tr>
        <tr>
          <td>
            <small class="d-block">{{ Detay.Kasa ? 'Kasa' : 'Hizmet' }}</small>
            {{ Detay.Kasa }}{{ Detay.Hizmet }}
          </td>
          <td>
            <small class="d-block">Kullanıcı</small>
            {{ Detay.Kullanici }}
          </td>
          <td>
            <small class="d-block">İşlem Tarihi</small>
            {{ Detay.tarih }}
          </td>
        </tr>
        </tbody>
      </table>
      <hr v-if="Detay.Odeme">
      <table class="table table-bordered table-sm" v-if="Detay.Odeme">
        <thead>
        <tr>
          <th colspan="2">HAREKET MAHSUP</th>
        </tr>
        <tr>
          <th class="text-left">No.</th>
          <th class="text-right">Tutar</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="o in Detay.Odeme">
          <td>{{ o.Hareket_id }}</td>
          <td class="text-right">{{ o.TutarText }}</td>
        </tr>
        </tbody>
      </table>
      <div slot="footer" class="dialog-footer el-button-group">
        <el-button size="small" type="warning" :loading="lo" v-if="Detay.eFaturaNo" @click="eFatura(Detay.eFaturaNo)">
          e-Fatura
        </el-button>
        <el-button size="small" type="danger" :loading="lo" @click="IslemIptal(Detay.id)">İşlemi İptal Et</el-button>
      </div>
    </el-dialog>
    <HareketIsle v-if="HareketModalDurum" :Cari="Bilgi" :Durum="HareketModalDurum"
                 @Durum="SayfaYukle"></HareketIsle>

    <OdemeIsle v-if="OdemeModalDurum" @Durum="SayfaYukle" :Cari="Bilgi" :Hareket="SeciliHareket"
               :Durum="OdemeModalDurum"></OdemeIsle>
  </div>
</template>

<script>

import XLSX from 'xlsx';

const make_cols = refstr => Array(XLSX.utils.decode_range(refstr).e.c + 1).fill(0).map((x, i) => ({
  name: XLSX.utils.encode_col(i),
  key: i
}));

import CariModal from "./Comp/CariModal";
import HareketIsle from "../Comp/HareketIsle";
import OdemeIsle from "../Comp/OdemeIsle";

export default {
  components: {OdemeIsle, HareketIsle, CariModal},
  props: ['Cari_id', 'Tur'],
  data() {
    return {
      lo: false,
      HareketModalDurum: false,
      OdemeModalDurum: false,
      CariModalDurum: false,
      DetayModalDurum: false,
      Bilgi: null,
      Ekstre: null,
      SeciliHareket: null,
      Unvan: '...',
      Height: null,
      AltToplam: null,
      Detay: null,
      ExcelData: null,
    }
  },
  methods: {
    eFatura(id) {
      this.lo = true
      this.$store.dispatch("Get", {path: 'rapor/faturagetir/' + id})
          .then(response => {
            this.lo = false;
            if (response.Durum == "OK") {

              this.windowRef = window.open(
                  "",
                  "",
                  "width=800,height=500,left=100,top=100"
              );
              this.windowRef.document.write(response.Html);
              this.windowRef.focus();
              this.windowRef.print();
              //this.windowRef.close();
            } else {
              this.$notify.error({
                title: response.Mesaj,
                customClass: 'error'
              });
            }
          })
    },
    Indir(evt) {

      const ws = XLSX.utils.json_to_sheet(this.ExcelData);
      const wb = XLSX.utils.book_new();
      ws['!cols'] = [
        {wch: 5},
        {wch: 12},
        {wch: 50},
        {wch: 12},
        {wch: 12},
        {wch: 12},
      ];

      wb.Props = {
        Title: this.SayfaAdi,
        Author: "MUDU APP",
        Manager: "MUDU APP",
        Company: "MUDU",
        Category: "Finans",
        Keywords: "Mudu",
        Comments: this.SayfaAdi,
      };

      XLSX.utils.book_append_sheet(wb, ws, this.SayfaAdi);
      XLSX.writeFile(wb, this.SayfaAdi + ".xlsx");
    },
    Getir() {
      this.lo = true
      this.$store.dispatch("Post", {...this.Form, path: 'rapor/kasa'})
          .then(response => {
            if (response.Durum === "OK") {
              this.lo = false
              this.Liste = response.Data
              this.ExcelData = response.ExcelData
              this.AltToplam = response.AltToplam
            }
          })
    },
    Yazdir() {
      this.$prompt('Yazdırılacak sayfanın adını değişebilirsiniz.', 'Sayfa Adı', {
        confirmButtonText: 'Yazıcıya Gönder',
        cancelButtonText: 'Vazgeç',
        inputValue: this.SayfaAdi,
        inputPlaceholder: 'Yazdırma Sayfası'
      }).then(({value}) => {
        this.SayfaAdi = value;
        this.YaziciyaGonder(value);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Yazdırma İptal Edildi'
        });
      });
    },
    YaziciyaGonder() {
      setTimeout(() => {
        window.print();
      }, 100);
    },
    OdemeAl(id, Tutar) {
      this.OdemeModalDurum = true
      this.SeciliHareket = {id: id, Tutar: Tutar}
    },
    DetayModalKapat() {
      this.DetayModalDurum = false
    },
    SayfaYukle() {
      this.SeciliHareket = null
      this.CariModalDurum = false
      this.lo = true
      this.$store.dispatch("Get", {path: 'cari/' + this.Cari_id})
          .then(response => {
            if (response.Durum === "OK") {
              this.Bilgi = response.Bilgi
              this.Ekstre = response.Ekstre
              this.ExcelData = response.ExcelData
              this.AltToplam = response.AltToplam
              this.lo = false
              this.HareketModalDurum = false
              this.OdemeModalDurum = false
              this.Unvan = response.Bilgi.Unvan
              this.SayfaAdi = response.Bilgi.Unvan
              this.$store.dispatch("title", this.Unvan);
            } else {
              this.$notify.error({
                title: response.Mesaj,
                customClass: 'error'
              });
              this.lo = false
            }
          })
    },
    TableSecim(e) {
      this.DetayModalDurum = true
      this.Detay = e
    },
    TableFooter() {
      const sums = [];
      sums[4] = this.AltToplam.A;
      sums[5] = this.AltToplam.V;
      sums[6] = this.AltToplam.B;
      return sums;
    },
    IslemIptal(id) {
      this.$confirm("Hareket iptal etme isteğinizi onaylayınız.", "İptal Onayı", {
        confirmButtonText: "Onayla",
        cancelButtonText: "İptal",
        type: 'warning'
      }).then(() => {
        this.SilOnay(id)
      }).catch(() => {
        this.$message.info("Oturum Kapatılmadı");
      });
    },
    SilOnay(id) {
      this.lo = true
      this.$store.dispatch("Delete", {path: 'hareket/' + id})
          .then(response => {
            if (response.Durum === "OK") {
              this.$notify.info({
                title: response.Mesaj,
                customClass: 'info'
              });
              this.DetayModalDurum = false
              this.SayfaYukle()
            } else {
              this.$notify.error({
                title: response.Mesaj,
                customClass: 'error'
              });
              this.lo = false
            }
          })

    }
  },
  created() {
    this.SayfaYukle()
    this.Height = window.innerHeight - 121
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Muhasebe/Cari/Detay.vue